<template>
  <main-rent :header="header" :first-available="firstAvailable">
    <p v-if="getCurrentProduct.promo_text" class="promo-text mt0">
      {{ getCurrentProduct.promo_text }}
    </p>
    <size :rent-type="'single'" />
    <p @click="scrollToTryOn" class="not-sure">
      {{ $t("Not sure about the size - try it on") }}
    </p>
    <delivery :rent-type="'single'" />
    <rent-period :rent-type="'single'" @updatePeriod="updatePeriod" />
    <payment :rent-type="'single'" />
  </main-rent>
</template>

<script>
import MainRent from './MainRent.vue'
import { Size, Delivery, RentPeriod, Payment } from 'theme/components/core/blocks/Product-v2/Rent/components'
import { mapGetters } from 'vuex'

export default {
  name: 'SingleRent',
  components: {
    MainRent,
    Size,
    Delivery,
    RentPeriod,
    Payment
  },
  props: {
    firstAvailable: {
      type: String,
      default: ''
    },
    scrollToTryOn: {
      type: () => {},
      default: () => {}
    }
  },
  data () {
    return {
      headerPrice: ''
    }
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct',
      getActivePeriod: 'calendar/getActivePeriod'
    }),
    header () {
      return {
        mainTitle: 'One-time rental',
        subtitle: this.subtitle,
        price: this.price,
        headerPrice: this.headerPrice
      }
    },
    cheapestRentPrice () {
      let onlyRental = this.getCurrentProduct.sirental_price && this.getCurrentProduct.sirental_price.filter(x => x.period !== 2 + 'd')
      return onlyRental && onlyRental.reduce((prev, curr) => Number(prev.price) < Number(curr.price) ? prev : curr).price;
    },
    subtitle () {
      return this.headerPrice ? `${this.$t('Rent for')} ${this.getStringForPeriod(this.getActivePeriod)}` : 'Rent for 1, 4 or 7 days'
    },
    price () {
      return this.headerPrice || this.cheapestRentPrice
    }
  },
  methods: {
    getStringForPeriod (period) {
      if (period === 2 || period === 1) {
        return '1' + ' ' + this.$t('day')
      } else if (period) {
        return period + ' ' + this.$t('days')
      }
      return ''
    },
    updatePeriod (value) {
      this.headerPrice = this.getCurrentProduct.sirental_price && this.getCurrentProduct.sirental_price.filter(x => x.period === value - 1 + 'd')[0].price
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-text {
  padding-bottom: 15px;
  border-bottom: 1px solid #D1D1D1;
}
.not-sure {
  color: #D81E1E;
  cursor: pointer;
  text-decoration: underline;
}
</style>
